import React from 'react';
import Button from 'react-bootstrap/Button';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import IdcardDiv from "../customNodes/idCard";
import CountrieSelection from '../customNodes/CountriesSelection';
import {
    getserverurl
} from "../dbconnector/connector";
import { HiOutlineChevronDown } from "react-icons/hi";
import { HiOutlineChevronUp } from "react-icons/hi";
import { MdCleaningServices } from "react-icons/md";
import { MdOutlineCheck } from "react-icons/md";
import { MdOutlineCancel } from "react-icons/md";

import { useState } from 'react';
import { useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LeidingNode from '../customNodes/LeidingNode';
import { setErrorMessage } from "../tools/errorhandling";



const HotelNode = ({ rights, t, isDisabled, cleaningtaskstoassignarray, kamersarray, kamertypesarray, cleaningtypearray, cleaningtaskarray, generalservicesarray, data, events, tabsDisabled, MousePosition }) => {
    const [selectedtab, setSelectedtab] = useState(0);
    const [tariefdisabled, settariefdisabled] = useState(true);
    const [mouseposition, setMousePosition] = useState({ x: 0, y: 0 });
    // const [tarief, settarief] = useState({});


    useEffect(() => {
       
        if (sessionStorage.getItem('leidingdetails') === 'block') {
            showdetails()
        }
        else if (sessionStorage.getItem('leidingdetails') === 'none') {
            hidedetails()
        } else { hidedetails() }
         
    }, [data]);

    useEffect(() => {
        if (sessionStorage.getItem('hotelcloseform') === 'true') {
            CloseForm()
        }
        setSelectedtab(Number(sessionStorage.getItem('selectedhoteltabid')))
    }, []);

    const handleMouseMove = (e) => {
        setMousePosition({ x: e.clientX + window.pageXOffset, y: e.clientY + window.pageYOffset })
    };

    const setselectedtab = (tabid) => {
        setSelectedtab(tabid)
        sessionStorage.setItem('selectedhoteltabid', tabid)
    }

    const CloseForm = () => {
        sessionStorage.setItem('hotelcloseform', 'true')
        document.getElementById('formcontent').style.display = 'none';
        document.getElementById('closeformchevronDown').style.display = 'block';
        document.getElementById('closeformchevronUp').style.display = 'none';
    }

    const OpenForm = () => {
        sessionStorage.setItem('hotelcloseform', 'false')
        document.getElementById('formcontent').style.display = 'block';
        document.getElementById('closeformchevronDown').style.display = 'none';
        document.getElementById('closeformchevronUp').style.display = 'block';
    }

    const disabletarief = () => {
        settariefdisabled(!tariefdisabled)
        events.seticondisabled(true);
        events.settabsdisabled(true)
    }

    // const handleitem = (e) => {
    //     console.log(e.target.name, ":", e.target.value)
    //     settarief((prev) => {
    //         return {
    //             ...prev,
    //             [e.target.name]: e.target.value
    //         }

    //     })
    //     console.log("tarief :", tarief)
    // }
    const setleiding = (e) => {
        //console.log("leiding = " + e.target.value);
        // events.handleitemchange(e)
        // document.getElementById('leiding1').style.display = 'none';
        // document.getElementById('leiding2').style.display = 'none';
        // document.getElementById('leiding3').style.display = 'none';
        // document.getElementById('leiding' + e.target.value).style.display = 'grid';
    }
    //setmouseposition

    const setmouseposition = (e) => {
        setMousePosition({ x: e.clientX + window.pageXOffset, y: e.clientY + window.pageYOffset })
    }

    const showdetails = () => {
        sessionStorage.setItem('leidingdetails', "block")
        //document.getElementById("leidingdetails").style.display = "block";
    }

    const hidedetails = () => {
        sessionStorage.setItem('leidingdetails', "none")
        //document.getElementById("leidingdetails").style.display = "none";
    }

    const handleCancel = () => {
        window.location.reload();
    }

    const openContract = () => {
        window.open(getserverurl() + data.hotel.Contract, "_blank")
    }

    return (
        <>
            <form className="form" onSubmit={events.onSubmit} autoComplete="off">
                <div style={{ display: "none" }} id="MyIcons">
                    <MdCleaningServices id="cleaningservices" />
                    <MdOutlineCheck id="IconSave" />
                    <MdOutlineCancel id="IconCancel" /></div>
                <div className='formCollapse'>
                    <label className='formtitle'>
                        {t('HotelDetails')} '{data.hotel.Name}'
                    </label>
                    <HiOutlineChevronDown onClick={OpenForm} id='closeformchevronDown' style={{ display: "none" }} />
                    <HiOutlineChevronUp onClick={CloseForm} id='closeformchevronUp' />
                </div>
                <div id="formcontent" className='bggreen'>
                    <br></br>
                    <label className='formtitleGroupBox'> {t('Algemeen')}</label>
                    <div className="groupbox">
                        <div className="formchild" id='FPactive'>
                            <label className='labelhotel'>
                                {t('Name')}:
                            </label>
                            <input id="hotelnaam" name="Name" required className="normalinput" value={data.hotel.Name} onChange={events.handleitemchange} type='text' disabled={isDisabled} ></input>
                            <label className='labelhotel'>
                                {t('Active')}:
                            </label>
                            <input id="hotelActive" type='checkBox' className="checkbox" value={data.hotel.active} name="active" onChange={events.changecheckbox} checked={data.hotel.active} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('NR_Dep')}:
                            </label>
                            <input id="afdeling" name="nr_afd" required className="normalinput" value={data.hotel.nr_afd} onChange={events.handleitemchange} type='number' disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('BTWnr')}:
                            </label>
                            <input id="btw" className="normalinput" required type='text' name="btw_nummer" value={data.hotel.btw_nummer} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('QAControl')}:
                            </label>
                            <select id="Perform_QAControl" name="Perform_QAControl" className="normalinput" type='text' value={data.hotel.Perform_QAControl} onChange={events.handleitemchange} disabled={isDisabled}>
                                <option value="1">{t('Blijvers')}</option>
                                <option value="2">{t('Vertrekkers')}</option>
                                <option value="3">{t('Blijvers') + " & " + t('Vertrekkers')}</option>
                                <option value="4">{t('None')}</option>
                            </select>
                            {/* <input id="Perform_QAControl" type='checkBox' className="checkbox" value={data.hotel.Perform_QAControl} name="Perform_QAControl" onChange={events.changecheckbox} checked={data.hotel.Perform_QAControl} disabled={isDisabled}></input> */}
                            <label className='labelhotel'>
                                {t('Multiple Cleaners')}:
                            </label>
                            <input id="multipleCleanersPerAssignment" type='checkBox' className="checkbox" value={data.hotel.multipleCleanersPerAssignment} name="multipleCleanersPerAssignment" onChange={events.changecheckbox} checked={data.hotel.multipleCleanersPerAssignment} disabled={isDisabled}></input>
                        </div>
                    </div>
                    <label className='formtitleGroupBox'> {t('Adres gegevens')}</label>
                    <div className="groupbox">
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t('Street')}:
                            </label>
                            <input id="straatnaam" type='text' required className="normalinput" name="straatnaam" value={data.hotel.straatnaam} onChange={events.handleitemchange} disabled={isDisabled} ></input>
                            <label className='labelhotel'>
                                {t('Nr')}:
                            </label>
                            <input id="huisnummer" type='number' required className="normalinput" name="huisnummer" value={data.hotel.huisnummer} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('Postbus')}:
                            </label>
                            <input id="bus" type='text' className="normalinput" name="bus" value={data.hotel.bus} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('ZipCode')}:
                            </label>
                            <input id="zipcode" type='number' required className="normalinput" name="zipcode" value={data.hotel.zipcode} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('Community')}:
                            </label>
                            <input id="gemeente" type='text' required className="normalinput" name="gemeente" value={data.hotel.gemeente} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('Country')}:
                            </label>
                            <CountrieSelection isDisabled={isDisabled} data={{ fieldname: "land", land: data.hotel.land, handleitemchange: events.handleitemchange }} cssClass="countrySelection" t={t} />
                            <label className='labelhotel'>
                                {t('GPSlocatie')}:
                            </label>
                            <input id="gpslocatie" type='text' className="normalinput" name="gps_locatie" value={data.hotel.gps_locatie} onChange={events.handleitemchange} disabled={isDisabled}></input>
                        </div>
                    </div>
                    <label className='formtitleGroupBox'> {t('Check-in at work')}</label>
                    <div className="groupbox">
                        <div className="formchild_top">
                            <label className='labelhotel'>
                                {t('Aangiftederwerken')}:
                            </label>
                            <input id="contractrelationNumber" type='text' className="normalinput" name="contractrelationNumber" value={data.hotel.contractrelationNumber} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <p></p><p></p>
                            <label className='labelhotel'>
                                {t('Startdatum')}:
                            </label>
                            <DatePicker required className="normalinput" placeholderText="dd/mm/yyyy" id="startdate_contractrelationNumber" selected={data.hotel.startdate_contractrelationNumber} onChange={(e) => events.changedate(e, "startdate_contractrelationNumber")} showIcon name="startdate_contractrelationNumber" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                            <label className='labelhotel'>
                                {t('Einddatum')}:
                            </label>
                            <DatePicker required className="normalinput" placeholderText="dd/mm/yyyy" id="enddate_contractrelationNumber" selected={data.hotel.enddate_contractrelationNumber} onChange={(e) => events.changedate(e, "enddate_contractrelationNumber")} showIcon name="enddate_contractrelationNumber" dateFormat="dd/MM/yyyy" disabled={isDisabled} />
                        </div>
                    </div>
                    <label className='formtitleGroupBox'> {t('Legal')}</label>
                    <div className="groupbox">
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t('Contactpersoon')}:
                            </label>
                            <input id="contactperson" type='text' className="normalinput" name="contactperson" value={data.hotel.contactperson} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('Contactnummer')}:
                            </label>
                            <input id="contactnumber" type='tel' className="normalinput" name="contactnumber" value={data.hotel.contactnumber} onChange={events.handleitemchange} disabled={isDisabled}></input>
                        </div>
                        <div id="uploaddiv" className="formchild">
                            <label className='labelhotel'>
                                {t('Contractopladen')}:
                            </label>
                            <input id="uploadContract" className="normalinput" type='file' accept='.pdf' onChange={(e) => events.setContract({ value: e.target.files[0] })}></input>
                        </div>
                         <div className="formchild">
                            <label className='labelhotel'>
                                {t('emailfactuur')}:
                            </label>
                            <input id="contactperson" type='text' className="normalinput" name="emailfactuur" value={data.hotel.emailfactuur} onChange={events.handleitemchange} disabled={isDisabled}></input>
                            <label className='labelhotel'>
                                {t('emaildagstaat')}:
                            </label>
                            <input id="contactnumber" type='tel' className="normalinput" name="emaildagstaat" value={data.hotel.emaildagstaat} onChange={events.handleitemchange} disabled={isDisabled}></input>
                        </div>
                        <div id="contractdiv" className="formchild" style={data.hotel.Hotel_ID === undefined ? { display: "none" } : { display: "grid" }} >
                            <label className='labelhotel'>
                                {t('Contract')}:
                            </label>
                            <input id="contract" name="contract" value={data.hotel.Contract} disabled={isDisabled} className='normalinput'></input>
                            <Button type="button" id="viewcontractButton" onClick={openContract} className="openContract">toon contract</Button>
                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t('Extragegevens')}:
                            </label>
                            <textarea id="Note" type='textarea' className="doublegrid" name="note" value={data.hotel.note} onChange={events.handleitemchange} disabled={isDisabled}></textarea>
                        </div>

                    </div>
                    <br></br>
                </div>
                  <div id="editDiv" className="formchildButton" style={data.hotel.Hotel_ID === undefined || isDisabled === false ? { display: "none" } : { display: "grid" }}>
                        <Button id="editButton" className='' onClick={events.handleEdit} disabled={tabsDisabled}>{t('Edit')}</Button>
                    </div>
                  
                  <div id="saveDiv" className="two_Buttons" style={isDisabled === true ? { display: "none" } : { display: "grid" }}>
                        <Button id="saveButton" type="submit" className='Savebutton'>{t('Save')}</Button>
                        <Button id="cancelButton" className='Savebutton' onClick={events.handleCancel}>{t('Cancel')}</Button>
                    </div>
            </form>

            <div className='form' style={data.hotel.Hotel_ID === undefined ? { display: "none" } : { display: "block" }}>
                <Tabs className="HotelTabs" selectedIndex={selectedtab}>
                    <TabList >
                        <Tab disabled={tabsDisabled} onClick={() => setselectedtab(0)}>{t('Kamers')}</Tab>
                        <Tab disabled={tabsDisabled} onClick={() => setselectedtab(1)}>{t('Kamertypes')}</Tab>
                        <Tab disabled={tabsDisabled} onClick={() => setselectedtab(2)}>{t('Schoonmaaktypes')}</Tab>
                        <Tab disabled={tabsDisabled} onClick={() => setselectedtab(3)}>{t('Schoonmaaktaken')}</Tab>
                        <Tab disabled={tabsDisabled} onClick={() => setselectedtab(4)}>{t('betaaldetaak')}</Tab>
                        <Tab onClick={() => setselectedtab(5)}>{t('Tarieven')}</Tab>
                    </TabList>
                    <TabPanel>
                        <div className='tabpanel'>
                            <Button id="addkamerButton" className='Savebutton' onClick={() => events.addKamerfield()} disabled={tabsDisabled}>{t('Kamertoevoegen')}</Button>
                            <div className={hotelcss.roomtableheader}><p>{t('Kamernummer')}</p><p>{t('Kamertype')}</p></div>
                            <div id='roomslist' className='list'>
                                <div id="kamersarray" >{kamersarray}</div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div className='tabpanel'>
                            <Button id="addkamertypes" className='Savebutton' onClick={events.addKamertypefield} disabled={tabsDisabled}>{t('Kamertypetoevoegen')}</Button>
                            <div className={hotelcss.roomtypestableheader}><p>{t('Description')}</p></div>
                            <div id='typeslist' className='list'>
                                <div id="kamerstypeaaray" >
                                    {kamertypesarray}
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div className='tabpanel'>
                            <Button id="saveButton" className='Savebutton' onClick={events.addCleaningtypefield} disabled={tabsDisabled}>{t('Schoonmaaktypetoevoegen')}</Button>
                            <div className={hotelcss.cleaningtypetableheader}><p>{t('Type')}</p><p>{t('Description')}</p><p>{t('Kamertype')}</p><p>{t('Doorlooptijd')}</p><p>{t('Schoonmaak Taken')}</p></div>
                            <div id='cleaningtypeslist' className='list'>

                                <div id="multiselectdiv" style={{ display: "none" }} className={hotelcss.cleanintypesdiv}>
                                    {cleaningtaskstoassignarray}
                                </div>

                                <div id="cleaningtypearray" >
                                    {cleaningtypearray}
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div className='tabpanel'>
                            <Button id="saveButton" className='Savebutton' onClick={events.addCleaningtaskfield} disabled={tabsDisabled}>{t('Schoonmaaktaaktoevoegen')}</Button>
                            <div className={hotelcss.cleaningtasktableheader}><p>{t('Description')}</p></div>
                            <div id='cleaningtaskslist' className='list'>
                                <div id="cleaningtaskarray" >
                                    {cleaningtaskarray}
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div className='tabpanel'>
                            <Button id="saveButton" className='Savebutton' onClick={events.addGeneralServicestaskfield} disabled={tabsDisabled}>{t('betaaldetaaktoevoegen')}</Button>
                            <div className={hotelcss.GStasktableheader}><p>{t('Description')}</p><p>{t('Doorlooptijd')}</p><p>{t('multiple')}</p><p>{t('Algemene_dienst')}</p></div>
                            <div id='generalservicestasklist' className='list'>
                                <div id="generalservicestaskarray" >
                                    {generalservicesarray}
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel >
                        <div className='tabpanel '>
                            {/* <div id="editDiv" className="formchildButton" style={tariefdisabled === false ? { display: 'none' } : { display: 'grid' }}>
                                <Button id="changeRates" className='Savebutton' disabled={tabsDisabled} onClick={disabletarief}>{t('Edit')}</Button>
                            </div>
                            <div id="saveDiv" className="two_Buttons" style={tariefdisabled === true ? { display: 'none' } : { display: 'grid' }}>
                                <Button id="SaveRates" className='Savebutton' onClick={events.onSubmit}>{t('Save')}</Button>
                                <Button id="cancelButton" className='Savebutton' onClick={events.handleCancel}>{t('Cancel')}</Button>
                            </div> */}
                            <div id="tariefgegevens" >
                                <label className='formtitleGroupBox margintop-10'>{t('Tarief gegevens')}</label>
                                <div className="groupbox">
                                    <div className="tarievenfieldset">
                                        <label className='labelhotel'>
                                            {t('Weektarief')}:
                                        </label>
                                        <input id="weektarief" type='decimal' required className="normalinput_3" name="weektarief" value={data.hotel.weektarief} onChange={events.handleitemchange} disabled={isDisabled}></input><p></p>
                                        <label className='labelhotel'>
                                            {t('zaterdagtarief')}:
                                        </label>
                                        <input id="zaterdagtarief" type='decimal' required className="normalinput_3" name="zaterdagtarief" value={data.hotel.zaterdagtarief} onChange={events.handleitemchange} disabled={isDisabled}></input><p></p>
                                        <label className='labelhotel'>
                                            {t('zon-feestdagtarief')}:
                                        </label>
                                        <input id="zon_feestdagtarief" type='decimal' required className="normalinput_3" name="zon_feestdagtarief" value={data.hotel.zon_feestdagtarief} onChange={events.handleitemchange} disabled={isDisabled}></input><p></p>
                                        <label className='labelhotel'>
                                            {t('Algemene_dienst')}:
                                        </label>
                                        <input id="Algemenedienst" type='decimal' required className="normalinput_3" name="algemenedienst" value={data.hotel.algemenedienst} onChange={events.handleitemchange} disabled={isDisabled}></input>
                                        <select className='adtype' disabled={isDisabled} defaultValue="0" id="ADeenheid" name="ADeenheid" value={data.hotel.ADeenheid} onChange={events.handleitemchange}>
                                            <option value="0">eur</option>
                                            <option value="1">uren</option>
                                        </select>
                                        <div id="leidingdetails" >
                                            <label className='formtitleGroupBox' > {t('Leidinggevende')}</label>
                                            <div className="groupbox_leidinggevende">
                                                <div className="leidingsel">
                                                    <label className='labelhotel'>{t('Tarieftype')}:</label>
                                                    <select className="normalinput" value={data.hotel.tarieftype} name="tarieftype" onChange={events.handleitemchange} id="tariefselection" disabled={isDisabled}>
                                                        <option value={0}>---</option>
                                                        <option value={1}>Bedrag per gecontrolleerde kamer</option>
                                                        <option value={2}>Betalende taken / extra werk</option>
                                                        <option value={3}>Vast bedrag per 2 weken</option>
                                                        <option value={4}>Vast bedrag per dag</option>
                                                        <option value={5}>Op basis van bezettingspercentage </option>
                                                    </select>
                                                </div>

                                                <div className="groupbox" style={data.hotel.tarieftype === 0 ? { display: "block" } : { display: "none" }}>
                                                    <div className="leidingtype">
                                                        <label className='labelhotel'> Geen tarief type geselecteerd </label>
                                                    </div>
                                                </div>
                                                <label  id="tarieftype_1_label"  className='formtitleGroupBox' style={data.hotel.tarieftype === 1 || data.hotel.tarieftype === "1"  ? { display: "block" } : { display: "none" }}> {t('Bedrag per gecontrolleerde kamer')}</label>
                                                <div id="tarieftype_1" className="groupbox" style={data.hotel.tarieftype === 1 || data.hotel.tarieftype === "1" ? { display:"block" } : { display:"none" }}>
                                                    <div className="leidingtype">
                                                        <label className='labelhotel'>{t('leiding tarief per kamer')}:</label>
                                                        <input type='decimal' value={data.hotel.tarief1_value} name="tarief1_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                    </div>
                                                </div>
                                                <label id="tarieftype_2_label" className='formtitleGroupBox' style={data.hotel.tarieftype === 2 || data.hotel.tarieftype === "2"  ? { display: "block" } : { display: "none" }}> {t('Betalende taken / extra werk')}</label>
                                                <div id="tarieftype_2" className="groupbox" style={data.hotel.tarieftype === 2 || data.hotel.tarieftype === "2"  ? { display: "block" } : { display: "none" }}>
                                                    <div className="leidingtype">
                                                        <label className='labelhotel'>{t('leiding tarief per betalende taak')}:</label>
                                                        <input type='decimal' value={data.hotel.tarief2_value} name="tarief2_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                    </div>
                                                </div>
                                                <label id="tarieftype_3_label" className='formtitleGroupBox' style={data.hotel.tarieftype === 3 || data.hotel.tarieftype === "3"  ? { display: "block" } : { display: "none" }}> {t('Vast bedrag per 2 weken')}</label>
                                                <div id="tarieftype_3" className="groupbox" style={data.hotel.tarieftype === 3 || data.hotel.tarieftype === "3"  ? { display: "block" } : { display: "none" }}>
                                                    <div className="leidingtype">
                                                        <label className='labelhotel'>{t('Vast Maandelijks bedrag')}:</label>
                                                        <input type='decimal'  value={data.hotel.tarief3_value} name="tarief3_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                    </div>
                                                </div>
                                                <label id="tarieftype_4_label" className='formtitleGroupBox' style={data.hotel.tarieftype === 4 || data.hotel.tarieftype === "4"  ? { display: "block" } : { display:"none" }}> {t('Vast bedrag per dag')}</label>
                                                <div id="tarieftype_4" className="groupbox" style={data.hotel.tarieftype === 4 || data.hotel.tarieftype === "4"  ? { display: "block" } : { display: "none" }}>
                                                    <div className="leidingtype">
                                                        <label className='labelhotel'>{t('Vast Dagelijks bedrag')}:</label>
                                                        <input type='decimal' value={data.hotel.tarief4_value} name="tarief4_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                    </div>
                                                </div>
                                                <label id="tarieftype_5_label" className='formtitleGroupBox' style={data.hotel.tarieftype === 5 || data.hotel.tarieftype === "5"  ? { display: "block" } : { display: "none" }}> {t('Op basis van bezettingspercentage ')}</label>
                                                <div  id="tarieftype_5" className="groupbox" style={data.hotel.tarieftype === 5 || data.hotel.tarieftype === "5"  ? { display: "block" } : { display: "none" }}>
                                                    <div className="leidingtype">
                                                        <label className='labelhotel'>{t('0 - 25%')}:</label>
                                                        <input type='decimal' value={data.hotel.tarief5_1_value} name="tarief5_1_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                        <label className='labelhotel'>{t('26 - 50%')}:</label>
                                                        <input type='decimal' value={data.hotel.tarief5_2_value} name="tarief5_2_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                        <label className='labelhotel'>{t('51 - 75%')}:</label>
                                                        <input type='decimal'  value={data.hotel.tarief5_3_value} name="tarief5_3_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                        <label className='labelhotel'>{t('76 - 100%')}:</label>
                                                        <input type='decimal'  value={data.hotel.tarief5_4_value} name="tarief5_4_value" onChange={events.handleitemchange} disabled={isDisabled} className='normalinput_3'></input>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div id="saveDiv" className="three_Buttons_fix">
                                                <Button id="cancelButton" className='Savebutton'>{t('Edit')}</Button>
                                                <Button id="cancelButton" className='Savebutton'>{t('Save')}</Button>
                                                <Button id="cancelButton" className='Savebutton'>{t('Cancel')}</Button>
                                            </div> */}
                                        </div>


                                        {/* <label className='labelhotel'>
                                            {t('Bezetting')}:
                                        </label> */}
                                        {/* <Button id="cancelButton" className='Savebutton' onClick={showdetails} onMouseDown={setmouseposition}>{t('Voeg toe')}</Button><p></p> */}
                                        {/* <div className='tabpanel'>
                                            <div className={hotelcss.Leidingtableheader}>
                                                <p>{t('Vast/Variabel')}</p>
                                                <p>{t('Interval')}</p>
                                                <p>{t('Percentage/Aantal')}</p>
                                                <p>{t('Start')}</p>
                                                <p>{t('Stop')}</p>
                                                <p>{t('Type')}</p>
                                                <p>{t('Status')}</p>
                                                <p>{t('Prijs')}</p>
                                            </div>
                                            <div id='generalservicestasklist' className={hotelcss.leidinglist}>
                                                <div id="generalservicestaskarray" >
                                                </div>
                                            </div>
                                        </div> */}
                                        {/* <fieldset id="leidingtype" className="fieldset" disabled={tariefdisabled} onChange={setleiding} value={data.hotel.leidingtype}>
                                        <input type="radio" id="leiding_1" name="leidingtype" value="1" className="radio" />
                                        <label for="leiding_1" className="radiolabel"> {t('Percent')}</label>
                                        <input type="radio" id="leiding_2" name="leidingtype" value="2" className="radio" />
                                        <label for="leiding_2" className="radiolabel">{t('Aantal')}</label>
                                        <input type="radio" id="leiding_3" name="leidingtype" value="3" className="radio" />
                                        <label for="leiding_3" className="radiolabel">{t('Vast')}</label>
                                    </fieldset> */}
                                    </div>
                                    {/* <input id="leiding" type='decimal' required className="normalinput" name="leiding" value={data.hotel.leiding} onChange={events.handleitemchange} disabled={isDisabled}></input> */}
                                </div>
                            </div></div>
                    </TabPanel>
                </Tabs>
                {/* <LeidingNode
                    rights={rights}
                    t={t}
                    assignmentDisabled={null}
                    data={null}
                    events={{
                        handleCancel: hidedetails,
                        handleMouseMove: handleMouseMove,
                        setMouseDown: events.setMouseDown,
                        stopMouseMove: events.stopMouseMove
                    }}
                    MousePosition={mouseposition} /> */}
            </div>
        </>
    );
}


export default HotelNode;